import React, { useState, useEffect } from 'react';
import { FaUser, FaClock, FaBrain, FaPlus, FaArrowLeft } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { APIURL } from "../../../Global";
import axios from "axios";
import './AssessmentHistory.css'
import { useAlert } from 'react-alert';
import GeneralAssessment from './GeneralAssessment';
import OrthoAssessment from './OrthoAssessment';
import NeuroAssessment from './NeuroAssessment';
import ReAssessmentDashboard from './ReAssessmentDashboard';
import ScaleDashboard from './ScaleDashboard'
const AssessmentHistory = ({ }) => {
  const [assessments, setAssessments] = useState([]);
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState('history');
  const alert = useAlert();
  const location = useLocation();
  const patientData = location?.state?.data
  const type = location?.state?.type
  useEffect(() => {
    fetchAssessments();
  }, []);

  useEffect(() => {
    console.log(selectedAssessment)
  }, [selectedAssessment])

  const fetchAssessments = async () => {
    try {
      setLoading(true);
      const tokenString = sessionStorage.getItem("usertoken");
      let v2 = tokenString.replace(/["]+/g, "");

      const response = await axios.get(`${APIURL}/api/v1/patient/therapy-assessment/?patient_id=${patientData.id}&assessment_form=${type || 'general'}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + v2,
        },
      });

      if (response.data.status === 'success') {
        const newAssessments = response.data.message.slice().reverse();
        setAssessments(newAssessments);

        if (selectedAssessment) {
          const updatedSelectedAssessment = newAssessments.find(
            assessment => assessment.id === selectedAssessment.id
          );

          if (updatedSelectedAssessment) {
            setSelectedAssessment(updatedSelectedAssessment);
          } else {
            setSelectedAssessment(null);
          }
        }
      } else {
        alert.error(response.data.message || 'Error Occured')
      }
    } catch (err) {
      console.error('Error fetching assessments:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = (type) => {
    setShow(type);
  };

  const handleBackToHistory = () => {
    setShow('history');
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-content">
          <div className="spinner"></div>
          <p>Loading assessments...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="assessment-history">
      <div>
        <div className="header-section" style={{ margin: 0 }}>
          <div className="header-left">
            {show !== 'history' ? (
              <button className="back-btn" onClick={handleBackToHistory}>
                <FaArrowLeft className="btn-icon" />
                Back to History
              </button>
            ) :
              <h1 className="page-title">
                Assessment History
              </h1>}
          </div>
          {(show === 'history' && selectedAssessment) && (
            <div style={{ display: 'flex', gap: '5px', width: 'fit-content' }}>
              {type === 'neuro' && <button
                className="new-assessment-btn"
                onClick={() => handleClick('score')}
                style={{ width: 'fit-content', height: '40px', padding: '10px' }}
              >
                Scale Scores
              </button>}

              <button
                className="new-assessment-btn"
                onClick={() => handleClick('re-assessment')}
                style={{ width: 'fit-content', height: '40px', padding: '10px' }}
              >
                Re-assessment
              </button>
            </div>
          )}
        </div>

        {/* Main Content Area */}
        <div className="main-content">
          {show === 're-assessment' ? (
            <ReAssessmentDashboard assessment_id={selectedAssessment?.id} patientData={patientData} type={type} />
          ) : show === 'score' ?
            <ScaleDashboard patientData={patientData} therapy_id={selectedAssessment?.therapy_consultation} /> : (
              <div className="history-view">
                {/* Fixed Assessment List */}
                <div className="assessment-list-section col-3">
                  <div className="list-container">
                    <div className="list-header">
                      <h2>Available Assessments</h2>
                      <p>{assessments.length} assessments found</p>
                    </div>

                    <div className="list-content">
                      {assessments.length === 0 ? (
                        <div className="empty-message">
                          Unable to load assessments or No assessments found
                        </div>
                      ) : (
                        assessments.map((assessment, index) => (
                          <div
                            key={assessment.id || index}
                            onClick={() => setSelectedAssessment(assessment)}
                            className={`assessment-item ${selectedAssessment?.id === assessment.id ? 'selected' : ''
                              }`}
                          >
                            <div className="item-content">
                              <div className="item-details">
                                {assessment.created_at && (
                                  <p className="item-date">
                                    {formatDate(assessment.created_at)}
                                  </p>
                                )}
                                {assessment.description && (
                                  <p className="item-description">
                                    {assessment.description}
                                  </p>
                                )}
                              </div>
                              <div className="item-arrow">›</div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>

                {/* Dynamic Details Section */}
                <div className="assessment-details-section col-9">
                  <div className="details-container">
                    {selectedAssessment ? (
                      type === 'general' ?
                        <GeneralAssessment
                          data={patientData}
                          editData={selectedAssessment}
                          isEditing={true}
                          onSubmit={fetchAssessments} />
                        : type === 'ortho' ?
                          <OrthoAssessment
                            data={patientData}
                            editData={selectedAssessment}
                            isEditing={true}
                            onSubmit={fetchAssessments} />
                          : type === 'neuro' ?
                            <NeuroAssessment
                              data={patientData}
                              editData={selectedAssessment}
                              isEditing={true}
                              onSubmit={fetchAssessments} />
                            : <div className="details-content">
                              <h2 className="details-title">
                                {selectedAssessment.title || selectedAssessment.name || 'Assessment Details'}
                              </h2>

                              <div className="details-sections">
                                <div className="detail-section">
                                  <label className="detail-label">Assessment ID: {selectedAssessment.id}</label>
                                </div>

                                {selectedAssessment.description && (
                                  <div className="detail-section">
                                    <label className="detail-label">Description</label>
                                    <p className="detail-value">{selectedAssessment.description}</p>
                                  </div>
                                )}

                                <div className="form-placeholder">
                                  <p>Form details will be displayed here in the next implementation phase</p>
                                </div>
                              </div>
                            </div>
                    ) : (
                      <div className="empty-selection">
                        <div className="empty-content">
                          <p className="empty-title">Select an assessment to view details</p>
                          <p className="empty-subtitle">Choose from the list on the left</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default AssessmentHistory;